import { render, staticRenderFns } from "./ProductCombinedProducts.vue?vue&type=template&id=6f0a69eb&scoped=true&"
import script from "./ProductCombinedProducts.vue?vue&type=script&lang=js&"
export * from "./ProductCombinedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a69eb",
  null
  
)

export default component.exports